import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { makePath } from 'helpers/link-generation';
import Button from 'components/Button';
import { Card } from 'components/Card';
import Message from 'components/Message';

import { notFoundMessages as messages } from './NotFound.messages';

const NotFound = ({ activeVenueId, isAuthenticated, isLoaded }) => (
  <Card centered loading={!isLoaded}>
    <img alt="404" src={require('static/img/NotFound/404.svg')} />
    <Message as="p" className="text--bold" message={messages.body1} />
    <Message as="p" className="text--bold" message={messages.body2} />
    {isAuthenticated ? (
      <>
        <Message as="p" message={messages.links} />
        <Message as={Link} to={makePath.editVenue(activeVenueId)} message={messages.editVenue} />
        <Message as={Link} to={makePath.editClass(activeVenueId)} message={messages.editClass} />
        <Message as={Link} to={makePath.classes()} message={messages.classes} />
        <Message as={Link} to={makePath.statsDynamic(activeVenueId)} message={messages.stats} />
      </>
    ) : (
      <>
        <Message as="p" message={messages.authError} />
        <Link to="/login">
          <Message as={Button} message={messages.logIn} />
        </Link>
      </>
    )}
  </Card>
);

NotFound.propTypes = {
  activeVenueId: PropTypes.number,
  isAuthenticated: PropTypes.bool,
  isLoaded: PropTypes.bool,
};

export default NotFound;
